import { ReactiveControllerHost } from 'lit';
import { isEqual } from 'lodash-es';
import { ApiReduxController } from '../../common/redux/controllers/api-redux-controller';
import { RootState, slices, store, userAPI } from '../redux/store';

export class ApiController extends ApiReduxController<RootState>  {
  constructor(host: ReactiveControllerHost) {
    super(host, store);
  }
  
  protected get apiStatusState() {
    return this.state[slices.api.name];
  }

  get apiState() {
    return this.state[userAPI.reducerPath];
  }

  override stateChanged(state: RootState, forceUpdate: boolean): void {
    if (forceUpdate || !isEqual(state[slices.api.name], this.apiStatusState)) {
      this.updateState(state);
      this.host.requestUpdate();
    }
  }
}
